module.exports = { release: function () { return '' } }